import { useEffect, useState } from "react";
import Button from "../button";
import styles from "./header.module.scss";

const links = [
    { label: "Sobre", href: "#sobre" },
    { label: "Skills", href: "#skills" },
    { label: "Projetos", href: "#projetos" },
    { label: "Contato", href: "#contato" },
];

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header className={`${styles["header"]} ${scrolled ? styles["scrolled"] : ""}`}>
            <div className={styles["inner"]}>
                <a href="#topo" className={styles["logo"]}>
                    {/* <span className={styles["logo-mark"]}>MB</span> */}
                    <span className={styles["logo-text"]}>Matheus Batista</span>
                </a>

                <nav className={`${styles["nav"]} ${open ? styles["open"] : ""}`}>
                    {links.map((link, index) => (
                        <a
                            key={link.href}
                            href={link.href}
                            className={styles["link"]}
                            onClick={() => setOpen(false)}
                        >
                            <span className={styles["link-index"]}>
                                0{index + 1}
                            </span>
                            {link.label}
                        </a>
                    ))}
                </nav>

                <div className={styles["actions"]}>
                    <Button href="#contato" variant="secondary">
                        Vamos conversar
                    </Button>
                    <button
                        type="button"
                        className={`${styles["toggle"]} ${open ? styles["active"] : ""}`}
                        onClick={() => setOpen(!open)}
                        aria-label="Menu"
                    >
                        <span />
                        <span />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
